import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { KeyIdea, DidYouKnow } from "@/components/Callouts";
import { Section } from "@/components/Section";

export default function EdSheeran13() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "13");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section eyebrow="Lesson 13" title="Heaven">
        <YouTubeEmbed videoId="tcJe02LBBns" title="Heaven — Ed Sheeran" />
        <NoteImage
          src="/notes/ed-sheeran/finals/13-heaven.png"
          caption="Jason's handwritten chord chart for this lesson."
        />
      </Section>

      <Section eyebrow="Chord analysis" title="B♭ major — verse, pre-chorus and chorus">
        {/* Jason's chart: verse Bb % F % Eb % (marked "vocoder"); pre Gm F | Eb | Gm F | Eb; chorus Bb F Gm Eb */}
        <RomanNumeralAnalysis
          label="Verse"
          caption="B♭ → F → E♭, two bars each."
          chords={[
            { chord: "Bb", rn: "I",  function: "Tonic",        pitches: ["Bb2","D3","F3","Bb3"] },
            { bar: true },
            { chord: "F",  rn: "V",  function: "Dominant",     pitches: ["F2","A2","C3","F3"] },
            { bar: true },
            { chord: "Eb", rn: "IV", function: "Pre-dominant", pitches: ["Eb3","G3","Bb3","Eb4"] },
          ]}
        />
        <RomanNumeralAnalysis
          label="Pre-chorus"
          caption="Gm → F → E♭, twice."
          chords={[
            { chord: "Gm", rn: "vi", function: "Submediant",   pitches: ["G2","Bb2","D3","G3"] },
            { chord: "F",  rn: "V",  function: "Dominant",     pitches: ["F2","A2","C3","F3"] },
            { bar: true },
            { chord: "Eb", rn: "IV", function: "Pre-dominant", pitches: ["Eb3","G3","Bb3","Eb4"] },
          ]}
        />
        <RomanNumeralAnalysis
          label="Chorus"
          caption="B♭ → F → Gm → E♭."
          chords={[
            { chord: "Bb", rn: "I",  function: "Tonic",        pitches: ["Bb2","D3","F3","Bb3"] },
            { chord: "F",  rn: "V",  function: "Dominant",     pitches: ["F2","A2","C3","F3"] },
            { chord: "Gm", rn: "vi", function: "Submediant",   pitches: ["G2","Bb2","D3","G3"] },
            { chord: "Eb", rn: "IV", function: "Pre-dominant", pitches: ["Eb3","G3","Bb3","Eb4"] },
          ]}
        />
        <KeyIdea title="A familiar loop in a new key">
          The chorus is I–V–vi–IV — the same loop as the verse of In Other Words (G → D → Em7 → C
          there), here in B♭ major. The verse and pre-chorus draw on the same four chords, but
          each leaves one out: the verse skips Gm, the pre-chorus skips B♭.
        </KeyIdea>
      </Section>
      <Section eyebrow="Takeaway" title="The vocoder verse">
        <DidYouKnow title="How a vocoder works">
          Jason's chart marks the verse "vocoder". A vocoder takes the changing tone colour of one
          sound — a voice — and imposes it on another, usually a keyboard playing chords. The
          result: the chords seem to sing the words.
        </DidYouKnow>
      </Section>
    </LessonShell>
  );
}
